import { isEmpty } from "lodash";
import Image from "next/image";
import { getCookie } from "../../framework/libs/cookie";
import { TOKEN_CONGDONG } from "../../framework/store/constants";
import http from "../../utilities/http";
import { useEffect, useState } from "react";

const contentType = (slug) => {
    let contentType = 'article';
    switch (slug) {
    case 'kho-anh':
        contentType = 'album';
        break;
    case 'album':
        contentType = 'album';
        break;
    case 'thao-luan':
        contentType = 'thread';
        break;
    case 'chuyen-gia':
        contentType = 'professional';
        break;
    }
    return contentType;
};

export default function Index({ article, slug }) {
    const [commentCount, setCommentCount] = useState("");
    const [showAllComment, setShowAllComment] = useState(false);
    useEffect(() => { getAllcomment(false); }, [commentCount]);
    useEffect(() => { if (showAllComment) { getAllcomment(true); } }, [showAllComment]);
    const getAllcomment = async (init) => {
        const res = await http(`community/${slug}/comments/index?page=`, {}, {
            body: { id: article?.id },
            method: 'POST',
            token: "Bearer " + getCookie(TOKEN_CONGDONG)
        }, 'v2');
        if (res.code == 200) {
            setCommentCount(res?.data?.length);
            if (init) { setCommentsG(res?.data); };
        };
    };
    const [userLogin, setUserLogin] = useState({});
    const [logined, setLogined] = useState(false);
    useEffect(() => { fetchUserLogin(); }, []);
    const fetchUserLogin = async () => {
        const url = `user`;
        const res = await http(url, {}, { token: "Bearer " + getCookie(TOKEN_CONGDONG) }, 'v2');
        setUserLogin(res);
        setLogined(!isEmpty(getCookie(TOKEN_CONGDONG)));
    };
    const [commentsG, setCommentsG] = useState(article?.comments?.data || []);
    const [changeComplete, setChangeComplete] = useState(false);
    useEffect(() => { if (changeComplete) { fetchComment(); } }, [changeComplete]);
    const fetchComment = async () => {
        const url = `community/${contentType(article?.post_type)}/${article?.id}`;
        const res = await http(url, {}, { token: "Bearer " + getCookie(TOKEN_CONGDONG) }, 'v2');
        setCommentsG(res?.data?.comments?.data);
        setChangeComplete(false);
    };
    const newComment = (reply) => {
        return (
            <div className={"groupComment-input " + (reply == "" || reply == replyId ? "" : "d-none ") + (logined ? "" : "d-none")}>
                <div className="groupComment-avatar">
                    <Image width={38} height={38} alt="" src={userLogin?.avatar ? userLogin?.avatar : "/images/img-sale02.png"} />
                </div>
                <div className="groupComment-form">
                    {reply != "" ?
                        <input className="form-control" type="text" placeholder="Bình luận" value={comment} onChange={e => { setComment(e.currentTarget.value); }}
                            onKeyUp={(e) => { (e.key === 'Enter' || e.keyCode === 13) ? onComment(reply) : ""; }}
                        /> :
                        <input className="form-control" type="text" placeholder="Bình luận" value={commentAll} onChange={e => { setCommentAll(e.currentTarget.value); }}
                            onKeyUp={(e) => { (e.key === 'Enter' || e.keyCode === 13) ? onComment(reply) : ""; }}
                        />
                    }
                    <div className="tools">
                        <button className="btn"
                            onClick={() => onComment(reply)}
                        >Gửi</button>
                    </div>
                </div>
            </div>
        );
    };
    const [replyId, setReplyId] = useState("");
    const [comment, setComment] = useState("");
    const [commentAll, setCommentAll] = useState("");
    const onComment = async (reply) => {
        const res = await http(`community/${contentType(article?.post_type)}/comments/store`, {}, {
            body: {
                id: article?.id,
                content: !isEmpty(reply.toString()) ? comment : commentAll,
                parent_id: reply || "",
                real_parent_id: reply || ""
            },
            method: 'POST',
            token: "Bearer " + getCookie(TOKEN_CONGDONG)
        }, 'v2');
        if (res?.code == 200) {
            if (isEmpty(reply.toString())) { setCommentAll(""); }
            setReplyId("");
            setComment("");
            setChangeComplete(true);
            getAllcomment(showAllComment);
        }
    };
    const [editComment, setEditComment] = useState("");
    const [editContent, setEditContent] = useState("");
    const onEdit = async (id) => {
        if (editContent != comment?.content) {
            const res = await http(`community/${contentType(article?.post_type)}/comments/update`, {}, {
                body: {
                    comment_id: id,
                    comment_content: editContent,
                },
                method: 'POST',
                token: "Bearer " + getCookie(TOKEN_CONGDONG)
            }, 'v2');
            if (res.code == 200) {
                setEditComment(false);
                setEditContent(editContent);
                setChangeComplete(true);
                getAllcomment(showAllComment);
            }
        }
    };
    const genComment = (comments, rootComment) => {
        if (isEmpty(comments) && !isEmpty(getCookie(TOKEN_CONGDONG))) return (<p>Hãy trở thành người đầu tiên bình luận về bài viết này!</p>);
        if (isEmpty(comments) && isEmpty(getCookie(TOKEN_CONGDONG))) return (<p>Hãy <a href="/login">đăng nhập</a> và trở thành người đầu tiên bình luận về bài viết này!</p>);

        return (<>
            {
                comments.map((comment, index) => {
                    const genChild = function () {
                        if (comment?.children?.data?.length > 0) { return genComment(comment?.children?.data); }
                    };
                    const actionLike = async () => {
                        const res = await http(`community/${contentType(article?.post_type)}/comments/likes/toggle`, {}, {
                            body: { id: comment?.id },
                            method: 'POST',
                            token: "Bearer " + getCookie(TOKEN_CONGDONG)
                        }, 'v2');
                        if (res.code == 200) { setChangeComplete(true); }
                        getAllcomment(showAllComment);
                    };
                    const onDelete = async () => {
                        const res = await http(`community/${contentType(article?.post_type)}/comments/destroy?=`, {}, {
                            body: {
                                id: article?.id,
                                comment_id: comment?.id
                            },
                            method: 'POST',
                            token: "Bearer " + getCookie(TOKEN_CONGDONG)
                        }, 'v2');
                        if (res.code == 200) { setChangeComplete(true); }
                        getAllcomment(showAllComment);
                    };
                    return (
                        <div key={index} className={"groupComment-lst " + (rootComment ? "" : "groupComment-lst--box")} >
                            <div className="groupComment-thumb">
                                <a href={`/thanh-vien/u/${comment.user.id}`} style={{ textDecoration: 'none' }}>
                                    <Image width={32} height={32} alt="" src={comment?.user?.avatar ? comment.user.avatar : "/images/icon-app.svg"} />
                                </a>
                            </div>
                            <div className="groupComment-content">
                                <a href={`/thanh-vien/u/${comment.user.id}`} style={{ textDecoration: 'none', color: 'black' }}>
                                    <p className="name">{comment?.user?.fullname}</p>
                                </a>
                                <p className={"text " + (editComment == comment?.id ? "d-none" : "")}>{comment?.content}</p>
                                <div className={"groupComment-input " + (editComment == comment?.id ? "" : "d-none")}>
                                    <div className={"groupComment-form "}>
                                        <input className="form-control" type="text" placeholder="Sửa bình luận"
                                            value={editContent} onChange={e => { setEditContent(e.currentTarget.value); }}
                                            onKeyUp={(e) => { (e.key === 'Enter' || e.keyCode === 13) ? onEdit(comment?.id) : ""; }}
                                        />
                                        <div className="tools">
                                            <button className="btn" onClick={() => onEdit(comment?.id)}
                                            >Gửi</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="groupComment-tools">
                                    <span className="date">{comment?.created_at_formatted}</span>
                                    <span className={"like " + (comment?.current_user_liked ? "active " : "") + (logined ? "" : "d-none")}
                                        onClick={() => actionLike()}
                                    >Thích</span>
                                    <span className={"reply " + (logined ? "" : "d-none")}
                                        onClick={() => {
                                            setReplyId(comment?.id);
                                            setComment("");
                                        }}
                                    >Trả lời</span>
                                    <span className={"reply " + (comment?.user?.id == userLogin?.id ? "" : "d-none")}
                                        onClick={() => {
                                            setEditContent(comment?.content);
                                            setEditComment(comment?.id);
                                        }}
                                    >Chỉnh sửa</span>
                                    <span className={"reply " + (comment?.user?.id == userLogin?.id ? "" : "d-none")} style={{ color: "red" }}
                                        onClick={() => { onDelete(comment?.id); }}
                                    >Xóa</span>
                                    <span className="numberLike" style={{ display: "inline-flex" }}>
                                        {comment?.interaction_count?.like_count_number}
                                        <div style={{ marginLeft: "5px", display: "inline-flex" }}>
                                            <Image width={13} height={12} alt="" src="/images/icon-heart.svg" />
                                        </div>
                                    </span>
                                </div>
                                {newComment(comment?.id)}
                                {genChild()}
                            </div>
                        </div>
                    );
                })
            }
        </>
        );
    };
    return (
        <div className="groupComment" id="comments">
            <h2 className="groupComment-title">Bình luận</h2>
            {genComment(commentsG, true)}
            {(!isEmpty(commentsG) && isEmpty(getCookie(TOKEN_CONGDONG))) && (<p className="mt-2">Hãy <a href="/login">đăng nhập</a> để bình luận về bài viết này!</p>)}
            {newComment("")}
            <p className={"groupComment-more " + (showAllComment ? "d-none" : "")}
                onClick={() => {
                    setShowAllComment(!showAllComment);
                }}>
                {commentCount > 3 &&
                    <span>Xem tất cả {commentCount} bình luận
                        <div style={{ verticalAlign: "sub", display: "inline-block", paddingLeft: "5px" }}>
                            <Image width={9} height={16} alt="" src="/images/icon-arrow-slider.svg" />
                        </div>
                    </span>}
            </p>
        </div>
    );
}

export const countdown = (x) => {
    let [time, setTime] = useState(x);
    let timeCount = setInterval(function () {
        // getCurrentDate

        if (time == 0) {
            setTime(0);
            return clearInterval(timeCount);
        } else {
            setTime(time - 1);
        }
    }, 1000);
    return time;
};